<div class="top-ranked" [ngClass]="{fixed: fixed}"
     *ngIf="videos.length">
    <div class="header d-flex align-items-center">
        <div class="logo-icon"></div>
        <h3 class="mb-0" [routerLink]="moreLink" style="cursor: pointer;">
            <!-- <i class="iconfont iconLOGO"></i> -->
            {{ title }}·排行榜
        </h3>
    </div>
    <div class="content"
         *ngIf="videos.length">
        <div class="ranked-items">
            <div class="rank"
                 *ngFor="let trendingVideo of videos | slice:0:9; let i = index">
                <div>
                    <span class="rank-pos">
                        <span class="number-{{i +1 }}" [ngClass]="{'light': !isDark}"></span>
                    </span>
                    <!-- <span class="rank-pos"
                          [ngClass]="{'rank1': i === 0, 'rank2': i === 1, 'rank3': i === 2}">{{ i + 1 }}</span> -->
                    <a [routerLink]="['/play',trendingVideo.key]" title="{{ trendingVideo.title }}" >{{ trendingVideo.title }}</a>
                    <!-- <i class="icon"
                       [ngClass]="{'icon-rankdown': trendingVideo.userData.trending === 1, 'icon-rankup': trendingVideo.userData.trending === 2, 'icon-rank-nochange': trendingVideo.userData.trending === 0}"></i> -->
                </div>
                <div class="tags" *ngIf="trendingVideo.cidMapperArray.length <= 1">
                    <span >{{trendingVideo.cid}}</span>
                    <span >{{trendingVideo.region}}</span>
                    <span >{{trendingVideo.published}}</span>
                    <span >{{trendingVideo.language}}</span>
                </div>
                <div class="tags" *ngIf="trendingVideo.cidMapperArray.length > 1">
                    <span >{{ trendingVideo.cidMapperArray[0] }}</span>
                    <span >{{ trendingVideo.cidMapperArray[1] }}</span>
                    <span >{{ trendingVideo.cidMapperArray.length > 2 ? trendingVideo.cidMapperArray[2] : trendingVideo.region }}</span>
                    <span >{{ trendingVideo.cidMapperArray.length > 2 ? trendingVideo.region : trendingVideo.published}}</span>
                </div>
                <div class="rate">
                    {{trendingVideo.rating}}
                </div>
            </div>
        </div>
        <!-- <div>
            <a class="w-100 more-link"
               [routerLink]="moreLink" target="_blank"> 更多 > </a>
        </div> -->
    </div>
</div>
